import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { RemoteContent, Title } from '@jupi/ui'
import BookingCard from '../components/BookingCard'
import { useBookings } from '../api/queries'
import { useBookingAccess } from '../features/calendar/bookingAccess'
import { useBookingLinkState } from '../features/calendar/bookingNavigation'

// The front page, replacing BookToday.php: every booking across the fleet
// for one day, with a date picker to step elsewhere.
export default function BookTodayPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const linkState = useBookingLinkState()
  const { canOpen } = useBookingAccess()
  const [day, setDay] = useState(() => new Date().toISOString().slice(0, 10))

  const from = new Date(`${day}T00:00:00`)
  const to = new Date(`${day}T23:59:59`)
  const { data: bookings = [], isLoading, error } = useBookings({ from, to })

  return (
    <Box>
      <Title label={t('nav.today')} />

      <Stack direction="row" spacing={1} sx={{ mb: 2, alignItems: 'center' }}>
        <TextField
          type="date"
          size="small"
          value={day}
          onChange={(e) => setDay(e.target.value)}
          // The native picker: on a phone it is the OS date wheel, which
          // beats anything a web widget can offer for one-handed use.
          slotProps={{ inputLabel: { shrink: true } }}
          label={t('booking.starts')}
        />
        <Button size="small" onClick={() => setDay(new Date().toISOString().slice(0, 10))}>
          {t('common.today')}
        </Button>
      </Stack>

      <RemoteContent isLoading={isLoading} error={error}>
        {bookings.length === 0 && !isLoading ? (
          <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
            {t('booking.noneToday')}
          </Typography>
        ) : (
          <Stack spacing={1}>
            {bookings.map((booking) => (
              <BookingCard
                key={booking.bookingId}
                booking={booking}
                // Someone else's booking is seen, not opened.
                onClick={canOpen(booking) ? () => navigate(`/bookings/${booking.bookingId}`, { state: linkState }) : undefined}
              />
            ))}
          </Stack>
        )}
      </RemoteContent>
    </Box>
  )
}
